import moment from 'moment';

const padDatePart = (value) => value.toString().padStart(2, '0');

const formatDateObject = (date) => `${date.getFullYear()}-${padDatePart(date.getMonth() + 1)}-${padDatePart(date.getDate())}`;

const normalizeServiceDate = (date) => {
  if (!date) {
    return undefined;
  }

  if (typeof date === 'string') {
    const parsedDateString = moment(date, 'YYYY-MM-DD', true);
    if (parsedDateString.isValid()) {
      return parsedDateString.format('YYYY-MM-DD');
    }

    return undefined;
  }

  if (date instanceof Date) {
    if (Number.isNaN(date.getTime())) {
      return undefined;
    }

    return formatDateObject(date);
  }

  const parsedDate = moment(date);
  if (!parsedDate.isValid()) {
    return undefined;
  }

  return parsedDate.format('YYYY-MM-DD');
};

const getServiceDateFromResyToken = (token, fallbackDate) => {
  if (typeof token !== 'string' || !token.startsWith('rgs://resy/')) {
    return normalizeServiceDate(fallbackDate);
  }

  const configParts = token.replace('rgs://resy/', '').split('/');
  const serviceDate = configParts[3];
  const parsedServiceDate = moment(serviceDate, 'YYYY-MM-DD', true);

  if (!parsedServiceDate.isValid()) {
    return normalizeServiceDate(fallbackDate);
  }

  return parsedServiceDate.format('YYYY-MM-DD');
};

export default getServiceDateFromResyToken;
